<template lang="pug">
div.padding
    div.row.m-t-sm
        div.col-md-12
            h5._300.margin.m-b-md {{ trans('category.title') }}

    div.box
        v-server-table(
            :url="api",
            :name="tableName",
            ref="datatable",
            :columns="columns",
            :options="options"
        )

            template(slot="code" slot-scope="props")
                optional-cell-value(v-model="props.row.code")

            template(slot="external_code" slot-scope="props")
                optional-cell-value(v-model="props.row.external_code")

            template(slot="description" slot-scope="props")
                optional-cell-value(v-model="props.row.description")

            template(slot="products" slot-scope="props")
                collection-counter(
                    label="name"
                    subject="products assigned"
                    :collection="props.row.products"
                )

        category-form(ref="categoryForm")
</template>

<script>
import Auth from '@js/plugins/auth';
import categoryForm from './category-form.vue';
import CollectionCounter from '@js/components/collection-counter';
import OptionalCellValue from '@js/components/optional-cell-value';

export default {
    components: {
        categoryForm,
        CollectionCounter,
        OptionalCellValue,
    },

    data() {
        let canManageItems = Auth.hasAnyPermission(
            'franchise_manage_items',
            'franchise_manage_categories',
        );

        let actionButtons = [
            {
                title: this.trans('category.create_category'),
                action: () => {
                    this.showCategory(null);
                },
            },
        ];

        if (!canManageItems) {
            actionButtons = [];
        }

        return {
            tableName: 'VUETABLE_CATEGORY',
            columns: [
                'name',
                'code',
                'external_code',
                'description',
                'products',
            ],
            options: {
                checkbox: canManageItems,
                sortable: ['name', 'code', 'external_code', 'description'],

                pdf_url: Laroute.route('franchise.inventory.category.export', {
                    type: 'PDF',
                }),

                csv_url: Laroute.route('franchise.inventory.category.export', {
                    type: 'CSV',
                }),

                xls_url: Laroute.route('franchise.inventory.category.export', {
                    type: 'XLSX',
                }),

                rowClickCallback: row => {
                    this.showCategory(row.id);
                },

                rowClassCallback: () => 'pointer',

                actionButtons: actionButtons,

                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.inventory.category.delete',
                    ),
                    delete_title: 'Delete Categories',
                },

                headings: {
                    external_code: 'External Code',
                },
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('franchise.inventory.category.index');
        },
    },

    created() {
        this.removeLimitState();
        window.addEventListener('beforeunload', this.removeLimitState);
    },

    mounted() {
        this.registerEvent();
    },

    methods: {
        showCategory(id) {
            this.$refs.categoryForm.$emit('show-category', id);
        },

        registerEvent() {
            this.$refs.categoryForm.$on('category-saved', () => {
                this.$refs.datatable.getData();
            });
        },

        removeLimitState() {
            let query = JSON.parse(
                localStorage.getItem(`vuetables_${tableName}`),
            );

            if (!_.isNull(query) && !_.isUndefined(query.perPage)) {
                query.perPage = 20;

                localStorage.setItem(
                    `vuetables_${tableName}`,
                    JSON.stringify(query),
                );
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/category/category-list.vue